export default __webpack_public_path__ + "static/countryBackground-94c98ae51f644cd6c045c33ba6c5a5f0.png";